// extracted by mini-css-extract-plugin
module.exports = {"title":"footer_title__q0weN","name":"footer_name__lmZPL","inner_container":"footer_inner_container__s5bl5","link":"footer_link__h90ik","current_path":"footer_current_path__ZMbnP"};